import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../style';
import { withStyles } from '@material-ui/core/styles';
import { docsInfoSidebarConfig } from '../../../../../redux/constants/docsInfoContentTypes';
import MUList from '../../../../ui/MUList';
import MUListItem from '../../../../ui/MUListItem';
import MUListItemText from '../../../../ui/MuListItemText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

class InfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedComponent: '',
    };
  }

  componentWillMount() {
    if (!this.props.location.state) {
      this.props.switchDocsMainContentToInfo();
      this.props.setDocsApiInfo('Info4', 'Info4', true);
      this.setState({ selectedComponent: 'Info4' });
    }
  }

  handleClick = (e, component) => {
    this.props.switchDocsMainContentToInfo();
    this.props.setDocsApiInfo(component, component, true);
    this.setState({ selectedComponent: component });
  };

  isComponentSelected = (currentId) => {
    const { selectedComponent } = this.state;
    if (selectedComponent === currentId) return true;

    for (const section of docsInfoSidebarConfig) {
      const components = [];

      if (section.component) components.push(section.component);
      (section.items || []).forEach(item => {
        if (item.component) components.push(item.component);
        (item.subItems || []).forEach(sub => {
          if (sub.component) components.push(sub.component);
        });
      });

      if (
        components.includes(selectedComponent) &&
        components.includes(currentId)
      ) {
        return true;
      }
    }

    return false;
  };

  renderSection = (section) => {
    const { classes } = this.props;
    const isSectionExpanded = !!this.props.expandedSections[section.title];

    return (
      <div key={section.title}>
        <MUListItem
          button
          onClick={(e) => {
            this.props.toggleSection(section.title, true);
            if (section.component) this.handleClick(e, section.component);
          }}
          selected={this.isComponentSelected(section.component) && this.props.isStatic}
          classes={{ root: classes.listItem, selected: classes.selected }}
        >

          <MUListItemText
            classes={{ primary: classes.listItemText }}
            primary={section.title}
          />
          {isSectionExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </MUListItem>

        {isSectionExpanded &&
          (section.items || []).map(item => {
            const hasSubItems = Array.isArray(item.subItems);
            const isItemExpanded = !!this.props.expandedSections[item.component];

            const siblingKeys = section.items
              .filter(s => s.component && s.component !== item.component)
              .map(s => s.component);

            if (hasSubItems) {
              return (
                <div key={item.component}>
                  <MUListItem
                    button
                    onClick={(e) => {
                      this.props.toggleSection(item.component, false, siblingKeys);
                      this.handleClick(e, item.component);
                    }}
                    selected={this.isComponentSelected(item.component) && this.props.isStatic}
                    classes={{ root: classes.listItem, selected: classes.selected }}
                  >
                    <MUListItemText
                      classes={{ primary: classes.listItemText }}
                      primary={item.display}
                    />
                    {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </MUListItem>

                  {isItemExpanded && (
                    <div className={classes.subListItem}>
                      {item.subItems.map(subItem => (
                        <MUListItem
                          disableGutters
                          key={subItem.component}
                          button
                          onClick={(e) => this.handleClick(e, subItem.component)}
                          selected={this.isComponentSelected(subItem.component) && this.props.isStatic}
                          classes={{
                            root:
                              this.state.selectedComponent === subItem.component
                                ? `${classes.subListItem} ${classes.selectedSubItem}`
                                : classes.subListItem,
                            selected: classes.selected
                          }}
                        >

                          <MUListItemText
                            classes={{ primary: classes.collapseItemText }}
                            primary={subItem.display}
                          />
                        </MUListItem>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <MUListItem
                key={item.component}
                button
                onClick={(e) => {
                  this.props.toggleSection(item.component, false, siblingKeys);
                  this.handleClick(e, item.component);
                }}
                selected={this.isComponentSelected(item.component) && this.props.isStatic}
                classes={{ root: classes.listItem, selected: classes.selected }}
              >
                <MUListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={item.display}
                />
              </MUListItem>
            );
          })}
      </div>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <MUList className={classes.list} component="nav">
        {docsInfoSidebarConfig.map(this.renderSection)}
      </MUList>
    );
  }
}

InfoSection.propTypes = {
  classes: PropTypes.object.isRequired,
  switchDocsMainContentToInfo: PropTypes.func,
  setDocsApiInfo: PropTypes.func,
  isStatic: PropTypes.bool,
  location: PropTypes.object,
  expandedSections: PropTypes.object.isRequired,
  toggleSection: PropTypes.func.isRequired,
};

export default withStyles(styles)(InfoSection);